import InvestCloseForm from './InvestCloseForm';

export default InvestCloseForm;
